// paHatidSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stores: [], // [{ id, storeName: "", orders: [{id, item:""}], instructions }]
};

const paHatidSlice = createSlice({
  name: "paHatid",
  initialState,
  reducers: {
    resetPaHatidState: () => initialState,
    setCustomerOrderStores: (state, action) => {
      state.stores = action.payload;
    },
    addStore: (state, action) => {
      state.stores.push(action.payload); // payload: {id, storeName:"", orders:[...]}
    },
    removeStore: (state, action) => {
      const id = action.payload;
      state.stores = state.stores.filter((s) => s.id !== id);
    },
    updateStoreName: (state, action) => {
      const { id, storeName } = action.payload;
      const s = state.stores.find((s) => s.id === id);
      if (s) s.storeName = storeName;
    },
    addOrderItem: (state, action) => {
      const { storeId, newItem } = action.payload; // {id, item:""}
      const s = state.stores.find((s) => s.id === storeId);
      if (s) s.orders.push(newItem);
    },
    updateOrderItem: (state, action) => {
      const { storeId, itemId, value } = action.payload;
      const s = state.stores.find((s) => s.id === storeId);
      if (!s) return;
      s.orders = s.orders.map((it) =>
        it.id === itemId ? { ...it, item: value } : it
      );
    },

    updateStoreSpecialInstruction(state, action) {
      const { storeId, value } = action.payload;
      const s = state.stores.find((s) => s.id === storeId);
      if (s) s.instructions = value;
    },

    removeOrderItem: (state, action) => {
      const { storeId, itemId } = action.payload;
      const s = state.stores.find((s) => s.id === storeId);
      if (!s) return;
      if (s.orders.length > 1) {
        s.orders = s.orders.filter((it) => it.id !== itemId);
      }
    },
  },
});

export const {
  resetPaHatidState,
  setCustomerOrderStores,
  addStore,
  removeStore,
  updateStoreName,
  addOrderItem,
  updateOrderItem,
  updateStoreSpecialInstruction,
  removeOrderItem,
} = paHatidSlice.actions;

export default paHatidSlice.reducer;
